import React from "react";
import { sliceString } from "../../theme/helpers";
import LikeIcon from "../Icons/LikeIcon";
import { ShowOff, Content, Author, Title, UserImage, LikesCount, Tag } from "./CardShowOff.styled";

var CardShowOff = function CardShowOff(_a) {
  var title = _a.title,
      author = _a.author,
      authorLabel = _a.authorLabel,
      imageUrl = _a.imageUrl,
      isLiked = _a.isLiked,
      isRewarded = _a.isRewarded,
      isRewardedLabel = _a.isRewardedLabel,
      starsCount = _a.starsCount,
      isHigher = _a.isHigher,
      onClick = _a.onClick,
      onVoteClick = _a.onVoteClick;
  return React.createElement(ShowOff, null, React.createElement(UserImage, {
    imageUrl: imageUrl,
    isHigher: isHigher,
    onClick: onClick
  }, isRewarded && React.createElement(Tag, null, isRewardedLabel)), React.createElement(Content, {
    isLiked: isLiked
  }, React.createElement("div", null, React.createElement(Title, null, sliceString(title, 52)), React.createElement(Author, null, authorLabel, ": ", author)), React.createElement("div", null, React.createElement(LikesCount, null, starsCount), React.createElement(LikeIcon, {
    onClick: onVoteClick
  }))));
};

export default CardShowOff;